// extracted by mini-css-extract-plugin
module.exports = {"container":"loadingWrapper_container__1DzQy","progress":"loadingWrapper_progress__3g5so"};